import { render, staticRenderFns } from "./GroupedUserSelect.vue?vue&type=template&id=4809e451&"
import script from "./GroupedUserSelect.vue?vue&type=script&lang=js&"
export * from "./GroupedUserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports